// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content-31wMfm0i"};